import React, { useState } from 'react';
import Sidebar from '../Layout/Sidebar/index';
import Header from '../Layout/Header/index';
import Footer from '../Layout/Footer';


const Hoc = (BaseComponent) => {
  
 return function EnhancedComponent(props) {
   return (
    // <div className='flex bg-slate-100'>
     <div className="flex min-h-screens md:h-full bg-slate-100">
     <Sidebar  />
     <span className="block w-full flex-col min-h-screen">
     <Header />
     <BaseComponent {...props} />
     <Footer />
     </span> 
     </div>
   );
 };
};

export default Hoc